import React from "react";
import { Container } from "react-bootstrap";
import styles from "./index.module.css";

const Footer = () => (
  <>
    <Container fluid="xl" className={`${styles.footer_container}`}>
      <div className={`${styles.footer_card}`}>
        <div className={`${styles.card_title}`}>
          <p>About Sun West and TACA</p>
        </div>
        <div className={`${styles.card_body}`}>
          <div>
            Established in 2000, The{" "}
            <span className={`${styles.red_text}`}>
              Autism Community in Action’s (TACA)
            </span>{" "}
            goal is help children with developmental disabilities be the very
            best they can be.
            <span className={`${styles.red_text}`}>
              {" "}
              Sun West is a proud sponsor of TACA.
            </span>{" "}
            We believe all children deserve a bright future and TACA has been
            making this a reality for thousands of children each year. We are
            proud to extend our support to TACA and lend a helping hand to the
            communities we serve.
            <div className={`${styles.last_line}`}>
              Visit{" "}
              <a href="https://www.swmc.com/autismheroes/">
                swmc.com/autismheroes
              </a>{" "}
              to know more.
            </div>
          </div>
        </div>
      </div>
    </Container>
    <div className={`${styles.bottom_line}`}>
      <p>
        Sun West Mortgage Company, Inc. is acting as the lender and offers
        financing to qualified borrowers. TACA - a third party organization is
        not affiliated with Sun West Mortgage Company, Inc. The name and logo of
        TACA are owned by TACA.
      </p>
    </div>
  </>
);

export default Footer;
